import qs from 'qs'
import React, { useEffect } from 'react'
import config from '../../config.json'
import { setQueryStringWithoutPageReloadPush } from '../helpers/FormatLinks'
import Page from '../page/Page'
import { CraftsList } from './CraftsList'
import { useTranslation } from 'react-i18next'
const Crafts = (props) => {
    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null
    const preview = collectionDetails ? collectionDetails['preview'] : null

    const getCrafts = async () => {
        const query = values

        setQueryStringWithoutPageReloadPush(qs.stringify(query))
    }

    useEffect(() => {
        if (typeof window !== 'undefined') getCrafts()
    }, [])

    const { t } = useTranslation('common')

    return (
        <Page
            id={'CraftsPage'}
            title={config.titles.crafts.replace(
                '{collectionName}',
                collectionName ? 'for ' + collectionName : '',
            )}
            description={config.descriptions.crafts.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={preview}
            banners={false}
            {...props}
            pageTitle={t('pages.craft_your_nfts')}
            pageSubtitle={t('pages.crafting_adventures_await')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Crafts',
                    link: '/crafts',
                },
            ]}
        >
            <CraftsList {...props} showFilters={true} page={'CraftsPage'} />
        </Page>
    )
}

export default Crafts
